import * as React from 'react'

import { Icon } from '~/components/icon/Icon'
import { styled } from '~/styled'

import { TreeIcon } from './TreeIcon'
import { TreeText } from './TreeText'

const StyledItemContent = styled('div', {
  base: [
    'w-full',
    'relative',
    'min-h-8',
    'pl-10',
    'flex',
    'items-center',
    'gap-2'
  ]
})

type TreeItemContentProps = React.ComponentProps<typeof StyledItemContent>

export const TreeItemContent = React.forwardRef<
  HTMLDivElement,
  TreeItemContentProps
>(({ children, ...rest }, ref) => (
  <StyledItemContent ref={ref} {...rest}>
    {
      React.Children.map(children, (child) => {
        if (typeof child === 'string' || typeof child === 'number') {
          return <TreeText>{child}</TreeText>
        }
        if (
          React.isValidElement<React.ComponentPropsWithoutRef<typeof Icon>>(
            child
          ) &&
          child.type === Icon
        ) {
          return <TreeIcon {...child.props} />
        }
        return child
      }) as React.ReactElement<unknown>[]
    }
  </StyledItemContent>
))
